import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Chip, CircularProgress } from "@mui/material";
import Filters from "../../../../../../assets/images/filters.svg";
import Threedots from "../../../../../../assets/images/PhosphorLine.svg";
import Refresh from "../../../../../../assets/images/ArrowCounterClockwise.svg";
import MultiSelectWithSearchInput from "Samarth Module/components/dropdown/MultiSelectWithInput";
import {fetchInTransitRecoveryGlobalExport,fetchInTransitRecoveryGlobalOverviewTable, fetchInTransitRecoveryGlobalFilters, fetchInTransitRecoveryGlobalFifoGraph, fetchInTransitRecoveryShipmentTable } from "../../../../../api/loss_to_action_engin";
import OverflowMenu from "Samarth Module/components/overflowMenu/OverflowMenu";
import MoreFilters from "Samarth Module/components/drawers/moreFilters";
import CustomiseColumns from "Samarth Module/components/drawers/CustomiseColumns";
import SnackBarMessage from "Samarth Module/components/snackbar/snackbar";
import styles from '../InTransitRecovery.module.css';
import InTransitRecoveryGlobalOverviewTable from "./InTransitRecoveryGlobalOverviewTable";
import InTransitRecoveryGlobalGraph from './InTransitRecoveryGlobalGraph';
import InTransitRecoveryGlobalVisibilityTable from './InTransitRecoveryGlobalVisibilityTable';
import newExcel from "../../../../../../assets/images/FileXls.svg";
import Slider from "../../../../../../assets/images/sliders 1.svg";
import Expand from '../../../../../../assets/images/expand.svg';
import CustomButton from "Samarth Module/components/buttons/CustomButton";
import WeightageTopNDialog from "../../WeightageTopNDialog";

const resolveTimeThresholdValue = (value) => {
    if (String(value ?? "").trim() === "-") {
        return "-";
    }
    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? "-" : String(numericValue);
};

const mergeOverviewRows = (overviewData) => {
    const totalRows = Array.isArray(overviewData?.total_data)
        ? overviewData.total_data
        : [];
    const dataRows = Array.isArray(overviewData?.data) ? overviewData.data : [];
    return [...totalRows, ...dataRows];
};

const buildFilterChips = (filterData, onFilterChange, defaultFilterData = []) => {
    const chips = [];
    const effectiveFilterData = Array.isArray(filterData) ? filterData : defaultFilterData;
    effectiveFilterData.forEach((filter, index) => {
        const selectedData = Array.isArray(filter.selectedData)
            ? filter.selectedData
            : [];
        if (filter.isFavourite || selectedData.length === 0) return;
        selectedData.forEach((selectedValue, subIndex) => {
            const updatedSelectedData = selectedData.filter(
                (_, currentIndex) => currentIndex !== subIndex
            );
            chips.push({
                key: `${filter.label}-${index}-${subIndex}`,
                label: selectedValue,
                onDelete: () => onFilterChange(filter.label, updatedSelectedData),
            });
        });
    });
    return chips;
};


const InTransitRecoveryGlobal = ({ sideViewTab }) => {
    const { accounts } = useMsal();
    const activeAccount = accounts[0];
    const [openWeightageDialog, setOpenWeightageDialog] = useState(false);
    const [weightageError, setWeightageError] = useState("");
    const [dialogLoading, setDialogLoading] = useState(false);
    const [weightage, setWeightage] = useState({
        Count: "0",
        Volume: "0",
        Value: "100"
    });
    const [topNValue, setTopNValue] = useState(10);
    const [timeValue, setTimeValue] = useState("-");
    
    // store previously saved values before dialog editing starts
    const previousWeightageRef = useRef({
        Count: "0",
        Volume: "0",
        Value: "100"
    });
    const previousTopNValueRef = useRef(10);
    const previousTimeValueRef = useRef("-");

    // Tracks whether the next filter API call is the very first one for this screen.
    // When 1, backend forces Shipment Status = "Delayed in transit" as the default filter.
    // After the first response, we flip this to 0 so the user can freely remove/change it.
    const initialLoadRef = useRef(1);

    const [isDrawerOpen, setIsDrawerOpen] = useState({
        filterDrawer: false,
        customiseDrawer: false,
    });
    const [tableData, setTableData] = useState([]);
    const [orderLossType, setOrderLossType] = useState("Order Loss");
    const [kpi, setKPI] = useState({
        "Loss Mitigated Quantity": 0,
        "Loss Mitigated Value": 0
    });
    const [graphData, setGraphData] = useState([]);
    const [visibilityTableData, setVisibilityTableData] = useState([]);
    const [paginationData, setPaginationData] = useState(null);
    const [sortingData, setSortingData] = useState({
        sortBy: "",
        sortOrder: "ASC",
        fieldsection: ""
    });

    const [filters, setFilters] = useState({
        inTransitRecoveryGlobalFiltersData: [],
        inTransitRecoveryGlobalColumnsData: []
    });

    const [selectedUOM, setSelectedUOM] = useState('Tonnes');
    const [loading, setLoading] = useState({
        initialLoading: true,
        dataLoading: false,
        tableBodyLoading: false,
        graphTableLoading: false,
        exportLoading: false,
    });
    const [snackBarObject, setSnackBarObject] = useState({
        snackbarOpen: false,
        message: "",
        type: "error",
    });
   const [showExpanded,setShowExpanded]=useState(false);
   const handleWeightageDialogOpen = () => {
    previousWeightageRef.current = { ...weightage };
    previousTopNValueRef.current = topNValue;
    previousTimeValueRef.current = timeValue;
    setWeightageError("");
    setOpenWeightageDialog(true);
    };

    const handleWeightageDialogClose = () => {
        setWeightage({ ...previousWeightageRef.current });
        setTopNValue(previousTopNValueRef.current);
        setTimeValue(previousTimeValueRef.current);
        setWeightageError("");
        setOpenWeightageDialog(false);
    };
    // UOM options
       const uomOptions = ['Cases', 'Tonnes', 'Eaches'];

    const fetchInitialData = async (InTransitRecoveryGlobalFilters = [], uom = selectedUOM) => {
        try {
            // Snapshot of what the user actually has selected for each label BEFORE the API call.
            // The backend recomputes `selectedData` as an intersection of every filter's IN(...) clause
            // against the DB, so values that don't co-exist with other selections get silently dropped.
            // We preserve the user's original selection so their chips don't disappear after the
            // filter API refresh. Only labels the frontend did NOT send (e.g. first-load auto-seeded
            // "Shipment Status") will use the backend's returned selectedData.
            const sentSelections = InTransitRecoveryGlobalFilters.reduce((acc, filter) => {
                acc[filter.label] = Array.isArray(filter.selectedData) ? filter.selectedData : [];
                return acc;
            }, {});

            const payload = {
                email: activeAccount.username,
                "uom": uom,
                filters: InTransitRecoveryGlobalFilters.reduce((acc, filter) => {
                    acc[filter.label] = filter.selectedData;
                    return acc;
                }, {}),
                "lossMitigationToggle": orderLossType,
                "type": "InTransit Recovery Global View",
                "initialload": initialLoadRef.current,
            };

            const inTransitRecoveryGlobalFiltersData = await fetchInTransitRecoveryGlobalFilters(payload);

            // After the very first filter call, subsequent calls must send initialload = 0
            // so that the backend does NOT force "Delayed in transit" back on if the user
            // has removed or changed the Shipment Status filter.
            if (initialLoadRef.current === 1) {
                initialLoadRef.current = 0;
            }

            const returnedFilters = inTransitRecoveryGlobalFiltersData["filters"] || [];
            const mergedFilters = returnedFilters.map(filter => (
                Object.hasOwn(sentSelections, filter.label)
                    ? { ...filter, selectedData: sentSelections[filter.label] }
                    : filter
            ));

            setFilters(prev => ({
                ...prev,
                inTransitRecoveryGlobalFiltersData: mergedFilters,
                inTransitRecoveryGlobalColumnsData: inTransitRecoveryGlobalFiltersData["columns"] || []
            }));

            fetchData(mergedFilters, 1, "", "ASC", uom, paginationData?.rowsPerPage);
        } catch (error) {
            console.error("Error fetching initial filter data:", error);
        } finally {
            setLoading(prev => ({ ...prev, initialLoading: false }));
        }
    };

    const fetchData = async (InTransitRecoveryGlobalFilters = [], page = 1, sortBy = "", sortOrder = "ASC", uom = selectedUOM, rowsPerPage = 15, fieldsection = "") => {
        // Use tableBodyLoading for pagination/sorting, dataLoading for filter changes
        const isFilterChange = page === 1 && !sortBy;
        setLoading(prev => ({
            ...prev,
            dataLoading: isFilterChange,
            tableBodyLoading: !isFilterChange
        }));

        try {
            const payload = {
                email: activeAccount.username,
                "uom": uom,
                filters: InTransitRecoveryGlobalFilters.reduce((acc, filter) => {
                    acc[filter.label] = filter.selectedData;
                    return acc;
                }, {}),
                "type": "InTransit Recovery Global View",
                "lossMitigationToggle": orderLossType || "Order Loss",
                "pagination": {
                    "page": page,
                    "rowsPerPage": rowsPerPage
                },
                "sorting": {
                    "sortBy": sortBy,
                    "sortOrder": sortOrder,
                    "fieldsection": fieldsection
                },
                "Weightage Percentage": {
                Count: Number(weightage.Count),
                Volume: Number(weightage.Volume),
                Value: Number(weightage.Value)
                },
                "top_n": Number(topNValue),
                "Time": resolveTimeThresholdValue(timeValue)
            };
            const [data, fifoGraphData, visiTableData] = await Promise.all([fetchInTransitRecoveryGlobalOverviewTable(payload), fetchInTransitRecoveryGlobalFifoGraph(payload), fetchInTransitRecoveryShipmentTable(payload)]);
            setGraphData(fifoGraphData?.data);
            setVisibilityTableData(visiTableData?.data);
            setTableData(mergeOverviewRows(data));
            setKPI(data?.kpi || { lossMitigatedQty: 0, lossMitigatedValue: 0 });
            setPaginationData(data?.pagination || null);
            setSortingData({
                sortBy: data?.sorting?.sortBy || sortBy,
                sortOrder: data?.sorting?.sortOrder || sortOrder,
                fieldsection: data?.sorting?.fieldsection || fieldsection
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(prev => ({
                ...prev,
                dataLoading: false,
                tableBodyLoading: false
            }));
        }
    };
    const fetchGraphAndVisibilityData = async (lossType) => {
        setLoading(prev => ({
            ...prev,
            graphTableLoading: true
        }));
        try {
            const payload = {
                email: activeAccount.username,
                uom: selectedUOM,
                filters: filters.inTransitRecoveryGlobalFiltersData.reduce((acc, filter) => {
                    acc[filter.label] = filter.selectedData;
                    return acc;
                }, {}),
                type: "InTransit Recovery Global View",
                lossMitigationToggle: lossType,
                "Weightage Percentage": {
                Count: Number(weightage.Count),
                Volume: Number(weightage.Volume),
                Value: Number(weightage.Value)
                },
                "top_n": Number(topNValue),
                "Time": resolveTimeThresholdValue(timeValue)
            };

            const [fifoGraphData, visiTableData] = await Promise.all([
                fetchInTransitRecoveryGlobalFifoGraph(payload),
                fetchInTransitRecoveryShipmentTable(payload)
            ]);

            setGraphData(fifoGraphData?.data || []);
            setVisibilityTableData(visiTableData?.data || []);
            setLoading(prev => ({
                ...prev,
                graphTableLoading: false
            }));
        } catch (error) {
            console.error("Error fetching graph / visibility data:", error);
        }
    };
    const fetchGraphAndOverview = async () => {
    if (!validateWeightage(weightage)) return;
    setDialogLoading(true);

    try {
        const overviewPayload = {
        email: activeAccount.username,
        uom: selectedUOM,
        filters: filters.inTransitRecoveryGlobalFiltersData.reduce((acc, f) => {
            acc[f.label] = f.selectedData;
            return acc;
        }, {}),
        pagination: {
            page: paginationData?.page || 1,
            rowsPerPage: paginationData?.rowsPerPage || 20
        },
        sorting: sortingData,
        type: "InTransit Recovery Global View",
        lossMitigationToggle: orderLossType,
        "Weightage Percentage": {
        Count: Number(weightage.Count),
        Volume: Number(weightage.Volume),
        Value: Number(weightage.Value)
        },
        "Time": resolveTimeThresholdValue(timeValue)
        };

        const graphPayload = {
        ...overviewPayload,
        top_n: Number(topNValue)
        };

        const [overviewRes, graphRes] = await Promise.all([
        fetchInTransitRecoveryGlobalOverviewTable(overviewPayload),
        fetchInTransitRecoveryGlobalFifoGraph(graphPayload)
        ]);

        setTableData(mergeOverviewRows(overviewRes));
        setGraphData(graphRes?.data || []);
        setPaginationData(overviewRes?.pagination || null);
        setSortingData(overviewRes?.sorting || sortingData);

        setOpenWeightageDialog(false); // ✅ auto close on success
    } catch (err) {
        console.error("Weightage submit error", err);
    } finally {
        setDialogLoading(false); // ✅ loader off always
    }
    };
    // Initial load - fetch filter options once
    useEffect(() => {
        // eslint-disable-next-line no-undef
        const currentPath = globalThis?.location?.pathname || "";
        if (currentPath.includes('/loss_to_action_engine')) {
            fetchInitialData();
        }
    }, []);

    // Handle page change and sorting
    const handlePageChange = (newPage, sortCol, sortDir, rowsPerPage, fieldsection = "") => {
        const sortBy = sortCol || sortingData.sortBy;
        const sortOrder = sortDir || sortingData.sortOrder;
        setSortingData({ sortBy, sortOrder, fieldsection });
        setPaginationData(prev => ({ ...prev, page: newPage, rowsPerPage }));
        fetchData(filters.inTransitRecoveryGlobalFiltersData, newPage, sortBy, sortOrder, selectedUOM, rowsPerPage, fieldsection);
    };

    // Toggle More Filters drawer
    const toggleFilterDrawer = useCallback(() => {
        setIsDrawerOpen(prev => ({ ...prev, filterDrawer: !prev.filterDrawer }));
    }, []);

    // Toggle Customize Columns drawer
    const toggleCustomizeDrawer = useCallback(() => {
        setIsDrawerOpen(prev => ({ ...prev, customiseDrawer: !prev.customiseDrawer }));
    }, []);

    // Handle filter selection changes
    const handleFilterChange = (label, selectedOptions) => {
        let newFilter;
        setFilters(prevFilters => {
            newFilter = {
                ...prevFilters,
                inTransitRecoveryGlobalFiltersData: prevFilters["inTransitRecoveryGlobalFiltersData"].map(filter =>
                    filter.label === label
                        ? { ...filter, selectedData: selectedOptions }
                        : filter
                )
            }
            return newFilter;
        });
        // Reset to page 1 when filters change
        fetchInitialData(newFilter["inTransitRecoveryGlobalFiltersData"], selectedUOM);
    };

    // Handle UOM change
    const handleUOMChange = (_label, selectedOptions = 'Tonnes') => {
        const newUOM = selectedOptions;
        setSelectedUOM(newUOM);
        fetchData(filters.inTransitRecoveryGlobalFiltersData, 1, "", "ASC", newUOM, paginationData?.rowsPerPage);
    };

    // Reset all filters - clear selectedData
    const resetFilter = () => {
        setFilters(prevFilters => ({
            ...prevFilters,
            inTransitRecoveryGlobalFiltersData: prevFilters["inTransitRecoveryGlobalFiltersData"].map(filter => ({
                ...filter,
                selectedData: []
            }))
        }));
        setSelectedUOM('Tonnes');
        fetchInitialData([], 'Tonnes');
    };

    // Logic to export table data to Excel
    const handleExportToExcel = async () => {
        setLoading(prev => ({
            ...prev,
            exportLoading: true,
        }));

        try {
            const payload = {
                email: activeAccount.username,
                "uom": selectedUOM,
                filters: filters["inTransitRecoveryGlobalFiltersData"].reduce((acc, filter) => {
                    acc[filter.label] = filter.selectedData;
                    return acc;
                }, {}),
                "type": "InTransit Recovery Global View",
                "Weightage Percentage": {
                    Count: Number(weightage.Count),
                    Volume: Number(weightage.Volume),
                    Value: Number(weightage.Value),
                },
                "Time": resolveTimeThresholdValue(timeValue),
                "lossMitigationToggle": orderLossType || "Order Loss",
                "sorting": {
                    "sortBy": sortingData.sortBy || "",
                    "sortOrder": sortingData.sortOrder || "DESC",
                    "fieldsection": sortingData.fieldsection || ""
                }
            };


            await fetchInTransitRecoveryGlobalExport(payload);

            setSnackBarObject({
                snackbarOpen: true,
                message: "File exported successfully",
                type: 'success'
            });
        } catch (error) {
            console.error("Error exporting data:", error);
            setSnackBarObject({
                snackbarOpen: true,
                message: "Error occurred while exporting file. Please try again later.",
                type: 'error'
            });
        } finally {
            setLoading(prev => ({
                ...prev,
                exportLoading: false,
            }));
        }
    };
    const handleExpand = () => {
        setShowExpanded(!showExpanded)
    }
    const handleCloseExpanded = () => {
        setShowExpanded(false);
    };
    // Logic to handle customization    
    const handleCustomization = () => {
        toggleCustomizeDrawer();
    }

    const closeSnackbar = useCallback(() => {
        setSnackBarObject((prev) => ({ ...prev, snackbarOpen: false }));
    }, []);

    // Function to format numbers in Indian currency format
    const formatIndianCurrency = (value) => {
        if (!value && value !== 0) return '0';

        const numValue = typeof value === 'string' ? Number.parseFloat(value) : value;

        if (Number.isNaN(numValue)) return '0';

        return numValue.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0
        });
    };
    const handleOrderLossToggle = () => {
        const newType =
            orderLossType === "Order Loss" ? "Order Loss + MSTN" : "Order Loss";

        setOrderLossType(newType);
        fetchGraphAndVisibilityData(newType);
    };

    // Chips for selected values from non-favourite (More Filters) selections
  const filterChips = useMemo(
        () =>
            buildFilterChips(
                filters.inTransitRecoveryGlobalFiltersData,
                handleFilterChange,
                []
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filters.inTransitRecoveryGlobalFiltersData]
    );
    const validateWeightage = (data, currentTopN = topNValue) => {
        if (data.Count.trim() === "") {
            setWeightageError("Count can't be empty");
            return false;
        }

        if (data.Volume.trim() === "") {
            setWeightageError("Volume can't be empty");
            return false;
        }

        if (data.Value.trim() === "") {
            setWeightageError("Value can't be empty");
            return false;
        }

        const total =
            Number(data.Count) +
            Number(data.Volume) +
            Number(data.Value);

        if (total !== 100) {
            setWeightageError("Sum of Count, Volume and Value must be 100%");
            return false;
        }

        if (String(currentTopN ?? "").trim() === "") {
            setWeightageError("Top N can't be empty");
            return false;
        }

        if (Number(currentTopN) <= 0) {
            setWeightageError("Top N must be greater than 0");
            return false;
        }

        if (Number(currentTopN) > 1000) {
            setWeightageError("Top N value is too large");
            return false;
        }

        setWeightageError("");
        return true;
        };
        
    return (
        <>
            {loading.initialLoading ? (
                <div className={styles.loaderContainer}>
                    <CircularProgress />
                </div>
            ) : (
                <div className={`${styles.container} ${loading.exportLoading ? styles.blurBackground : ''}`}>
                    <div className={styles.fixedFilterSection}>
                        <div className={styles.sectionContainer}>

                            {filters["inTransitRecoveryGlobalFiltersData"]
                                .filter((filter) => filter.isFavourite)
                                .map((filter, index) => (
                                    <div key={`${filter.label}-${index}`} className={styles.filterWrapper}>
                                        <MultiSelectWithSearchInput
                                            key={`${filter.label}-${index}`}
                                            label={filter.label}
                                            options={filter.data}
                                            filterValues={filter.selectedData}
                                            isMultiSelect={filter.isMultiSelect}
                                            handleFilter={handleFilterChange}
                                            type="In-Transit Recovery"
                                            defaultValue={filter.defaultValue || []}
                                        />
                                    </div>
                                ))}

                            {/* UOM Filter */}
                            <div className={styles.filterWrapper}>
                                <MultiSelectWithSearchInput
                                    label="Units"
                                    options={uomOptions}
                                    filterValues={[selectedUOM]}
                                    isMultiSelect={false}
                                    handleFilter={handleUOMChange}
                                    type="In-Transit Recovery"
                                    defaultValue="Tonnes"
                                />
                            </div>
                            <div className={styles.iconContainer}>
                                <button
                                    type="button"
                                    onClick={resetFilter}
                                    className={styles.iconStyling}
                                    style={{ border: "none", padding: 0, display: "inline-flex" }}
                                    aria-label="Refresh filter"
                                >
                                    <img
                                        src={Refresh}
                                        className={styles.iconStyling}
                                        alt="refresh filter"
                                    />
                                </button>
                                <OverflowMenu
                                    menuItems={[
                                        {
                                            label: 'More Filters',
                                            icon: Filters,
                                            onClick: toggleFilterDrawer,
                                        }
                                    ]}
                                    Icon={Threedots}
                                />
                            </div>
                        </div>

                        {filterChips.length > 0 && (
                            <div className={styles.filtersBtnContainer}>
                                <Box className={styles.chipContainer}>
                                    {filterChips.map(chip => (
                                        <Chip key={chip.key} label={chip.label} onDelete={chip.onDelete} />
                                    ))}
                                </Box>
                            </div>
                        )}
                    </div>

                    {loading.dataLoading ? (
                        <div className={styles.loaderContainer}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <div className={styles.scrollableContent}>
                        <div style={{padding:"15px", background:"white",marginBottom:"10px",maxHeight:"430px"}}>
                            <div className={styles.segmentedToggle}>
                                <button
                                    className={`${styles.segment} ${orderLossType === "Order Loss" ? styles.active : ""
                                        }`}
                                    onClick={handleOrderLossToggle}
                                >
                                    Order Loss
                                </button>

                                <button
                                    className={`${styles.segment} ${orderLossType === "Order Loss + MSTN" ? styles.active : ""
                                        }`}
                                    onClick={handleOrderLossToggle}
                                >
                                    Order Loss + MSTN
                                </button>
                            </div>
                 {loading.graphTableLoading ? (
                                <div className={styles.loaderContainer}>
                                    <CircularProgress />
                                </div>
                            ) : (
                                <div className={styles.graphWrapper}>
                                    <div className={styles.graphCard}>
                                    <span className={styles.cardTitle}>
                                    {orderLossType} by Value Graph
                                <div className={styles.simpleTooltip}>
                                <button
                                    className={styles.tooltipButton}
                                    onClick={handleWeightageDialogOpen}
                                >
                                    Weighted Average & Top N
                                </button>

                                <span className={styles.tooltipText}>
                                    Weighted Average defines priority score using Count, Volume & Value.
                                    <br />
                                    Top N controls how many high-priority records are shown.
                                </span>
                                </div>
                                    </span>
                                        <InTransitRecoveryGlobalGraph
                                            data={graphData}
                                            orderLossType={orderLossType}
                                            topNKey={topNValue}
                                        />
                                    </div>

                                    <div className={styles.graphCard}>
                                        <span className={styles.cardTitle}>
                                            {orderLossType} by Value Shipment Table
                                        </span>
                                        <InTransitRecoveryGlobalVisibilityTable
                                            data={visibilityTableData}
                                            orderLossType={orderLossType}
                                        />
                                    </div>
                                </div>
                            )}
                        <div className={styles.intrMainBody}>
                            <div className={styles.intrHeader}>
                                <div>
                                    <span>Overview</span>
                                    <span className={styles.intrKPI}>
                                        <span className={styles.kpiHeading}>Loss Mitigated Quantity:</span>
                                        &nbsp;
                                        <span className={styles.kpiValue}>{formatIndianCurrency(kpi["Loss Mitigated Quantity"])}</span>
                                        &nbsp;
                                        <span aria-hidden="true">|</span>
                                        &nbsp;
                                        <span className={styles.kpiHeading}>Loss Mitigated Value:</span>
                                        &nbsp;
                                        <span className={styles.kpiValue}>₹{formatIndianCurrency(kpi["Loss Mitigated Value"])}</span>
                                    </span>
                                </div>
                                <div className={styles.customButtonGroup}>
                                    <CustomButton icon={Slider} label="Customise" type="mm-save" onClick={handleCustomization} />
                                    <CustomButton icon={newExcel} label="Export" type="mm-save" onClick={handleExportToExcel} />
                                     <div className={styles.segmentedBtn}>
                                                <button
                                                    type="button"
                                                    className={styles.segment}
                                                    style={{ padding: "6px", background: "white", border: "1px solid #e5e7eb", cursor: "pointer" }}
                                                    onClick={handleExpand}
                                                    title="Expand / Zoom"
                                                >
                                                    <img src={Expand} alt="Expand" className={styles.icon} />
                                                </button>
                                    </div>
                                </div>
                            </div>
                            <InTransitRecoveryGlobalOverviewTable
                                data={tableData}
                                columns={filters["inTransitRecoveryGlobalColumnsData"]}
                                paginationData={paginationData}
                                sortingData={sortingData}
                                handlePageChange={handlePageChange}
                                isLoading={loading.tableBodyLoading}
                            />
                            </div>
                        </div>
                        </div>
                    )}

                    {isDrawerOpen.filterDrawer && (
                        <MoreFilters
                            anchor={'right'}
                            filterDrawer={isDrawerOpen.filterDrawer}
                            handleFilterDrawer={toggleFilterDrawer}
                            rmpmFilters={filters["inTransitRecoveryGlobalFiltersData"]}
                            type={"InTransit Recovery Global View"}
                            setRmpmFilters={(filters) => {
                                setFilters(prevFilters => ({
                                    ...prevFilters,
                                    inTransitRecoveryGlobalFiltersData: filters
                                }));
                                fetchInitialData(filters);
                            }}
                            username={activeAccount.username}
                            limit={9}
                        />
                    )}

                    {isDrawerOpen.customiseDrawer && (
                        <CustomiseColumns
                            anchor={'right'}
                            columns={[...filters["inTransitRecoveryGlobalColumnsData"]]}
                            isOpen={isDrawerOpen.customiseDrawer}
                            handleCustomizeDrawer={toggleCustomizeDrawer}
                            columnCustomization={(customizedColumns) => {
                                setFilters(prevFilters => ({
                                    ...prevFilters,
                                    inTransitRecoveryGlobalColumnsData: customizedColumns
                                }));
                                toggleCustomizeDrawer();
                            }}
                            username={activeAccount.username}
                            type={"InTransit Recovery Global View"}
                        />
                    )}
                </div>
            )}
            {loading.exportLoading && (
                <div className={styles.exportOverlay}>
                    <div className={styles.exportLoader}>
                        <CircularProgress />
                        <div style={{ marginTop: 10, fontSize: 14 }}>
                            Exporting file...
                        </div>
                    </div>
                </div>
            )}
                        {showExpanded && (
                <div className={styles.expandedOverlay}>
                    <div className={styles.expandedContainer}>

                        {/* Header with Close Button */}
                        <div className={styles.expandedHeader}>
                            <span>In-Transit Global Overview</span>
                            <button
                                className={styles.closeButton}
                                onClick={handleCloseExpanded}
                            >
                                ✕
                            </button>
                        </div>

                        {/* Table */}
                        <div className={styles.expandedTableWrapper}>
                            <InTransitRecoveryGlobalOverviewTable
                                data={tableData}
                                columns={filters["inTransitRecoveryGlobalColumnsData"]}
                                paginationData={paginationData}
                                sortingData={sortingData}
                                handlePageChange={handlePageChange}
                                isLoading={loading.tableBodyLoading}
                            />
                        </div>

                    </div>
                </div>
            )}
            {snackBarObject.snackbarOpen && (
                <SnackBarMessage
                    type={snackBarObject.type}
                    snackbarMessage={snackBarObject.message}
                    snackbarOpen={snackBarObject.snackbarOpen}
                    setSnackbarOpen={closeSnackbar}
                />
            )}
            <WeightageTopNDialog
            open={openWeightageDialog}
            onClose={handleWeightageDialogClose}
            weightage={weightage}
            setWeightage={setWeightage}
            topNValue={topNValue}
            setTopNValue={setTopNValue}
            weightageError={weightageError}
            validateWeightage={validateWeightage}
            dialogLoading={dialogLoading}
            onSubmit={fetchGraphAndOverview}
            showTimeThreshold={true}
            timeValue={timeValue}
            setTimeValue={setTimeValue}
            timeLabel="Truck InTransit Time (hours)"
            />
        </>
    );
};

InTransitRecoveryGlobal.propTypes = {
    sideViewTab: PropTypes.string,
};

export default InTransitRecoveryGlobal;